import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.integration-office-365', {
        url: '/integration-office-365',
        component: 'companyManageApplicationIntegrationDevelopersIntegrationOffice365',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration-office-365/integration-office-365.state.js